import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as MediaActions from "../../data/media/MediaActions";

import UploadDropzone from './UploadDropzone';

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
});

const mapDispatchToProps = {
    uploadFile: MediaActions.uploadFile,
    fetchMediaList: MediaActions.fetchMediaList
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UploadDropzone)
);
